import { EinstellungTyp, settingsService } from '@/services/settingsService';
import { defineStore } from 'pinia';

export interface UserSettings {
  language: string;
  itemsPerPage: number;
  emailNotifications: boolean;
  browserNotifications: boolean;
  compactMode: boolean;
}

const defaultSettings: UserSettings = {
  language: 'de',
  itemsPerPage: 10,
  emailNotifications: true,
  browserNotifications: true,
  compactMode: false
};

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    settings: { ...defaultSettings }
  }),

  actions: {
    async loadSettings(options?: { skipApiCall?: boolean }) {
      try {
        // Wenn skipApiCall Option gesetzt ist, keine API-Anfrage senden
        if (options?.skipApiCall) {
          console.log('API-Aufruf für Einstellungen übersprungen');
          // Nur die Default-Einstellungen verwenden
          this.settings = { ...defaultSettings };
          return;
        }

        // Einstellungen vom Backend laden
        const backendSettings = await settingsService.getSettings(
          EinstellungTyp.BenutzerEinstellungen
        );

        if (backendSettings) {
          // Geladene Einstellungen mit Defaults zusammenführen
          this.settings = { ...defaultSettings, ...backendSettings };
        } else {
          // Falls keine Einstellungen gefunden wurden, Standardwerte verwenden
          this.settings = { ...defaultSettings };
        }
      } catch (error) {
        console.error('Fehler beim Laden der Einstellungen:', error);
        // Im Fehlerfall Standardeinstellungen verwenden
        this.settings = { ...defaultSettings };
        throw error;
      }
    },

    async saveSettings(newSettings: UserSettings) {
      try {
        // Einstellungen im Backend speichern
        await settingsService.saveSettings(EinstellungTyp.BenutzerEinstellungen, newSettings);
        // Lokalen State aktualisieren
        this.settings = { ...newSettings };
      } catch (error) {
        console.error('Fehler beim Speichern der Einstellungen:', error);
        throw error;
      }
    }
  }
});
